import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { navigation } from 'tio-common/utils/navigation';
import type SessionContextService from 'tio-employee/services/session-context';
import type PreRegisterService from 'tio-employee/services/pre-register';
import type SessionService from 'tio-employee/services/session';
import type CableService from 'tio-common/services/cable';

export default class LogoutRoute extends Route {
  @service declare sessionContext: SessionContextService;
  @service declare preRegister: PreRegisterService;
  @service declare session: SessionService;
  @service declare cable: CableService;

  async beforeModel() {
    // Capture the IdP's SLO URL before clearing session state, since
    // preRegister settings are available pre-auth and won't be affected by logout.
    // A session that ended on its own lands on /logged-out, not /login: /login
    // bounces an SSO tenant straight back through the IdP and signs it in again.
    const { skipIdpLogout } = this.session;
    this.session.skipIdpLogout = false;
    const idpSloUrl = skipIdpLogout ? undefined : this.preRegister.settings?.idpSloUrl;

    this.cable.disconnect();

    // Prevent handleInvalidation from firing a competing transition to /logout
    // by flagging the session, then performing a full logout.
    this.session.isLoggingOut = true;
    await this.sessionContext.logout();

    // Both branches leave via a full page load: this is the last hop out of the
    // authenticated state, so it is where the next login gets a clean app.
    navigation.hardNavigate(idpSloUrl || '/logged-out');
  }
}
